import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';
import { Link } from 'react-router';

class PaperS extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">


          <div className="new_banner">
            <div className="banner_content">
              <h1>CSCI 2023</h1>
              <h6>The 2023 International Conference on</h6>
              <h6>Computational Science and Computational Intelligence (CSCI)</h6>
              <h6>December 13-15, 2023, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Paper Submission</h4>
            <div className="par">
            Submissions are to be uploaded to the submission/evaluation web site portal at: <a href="https://american-cse.org/drafts/" target="_blank" rel="noopener noreferrer">https://american-cse.org/drafts/</a> <br />
            However, before doing so, please read the instructions below.

                <br /><br />
                All accepted papers of all research_tracks will be published by Conference Publishing Services, <a target="_blank" href="https://www.computer.org/conferences/cps">CPS </a>
                as part of the proceedings of The 2023 International Conference on Computational Science and Computational Intelligence (CSCI'23).
                <br/>
                Past conference proceedings can be accessed via IEEE Xplore Digital Library at: <br/> <br/>
                <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/tocresult.jsp?isnumber=6822065">Volume I (2014)</a><br/>
                <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/tocresult.jsp?isnumber=6822285">Volume II (2014)</a><br/>
                <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/mostRecentIssue.jsp?punumber=7420813">Volume (2015)</a><br/>
                <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/mostRecentIssue.jsp?punumber=7879541">Volume (2016)</a><br/>
                <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/mostRecentIssue.jsp?punumber=8554238">Volume (2017)</a><br/>
                <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/8859311/proceeding">Volume (2018)</a><br/>
                <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/9052554/proceeding">Volume (2019)</a><br/>
                <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/9457837/proceeding">Volume (2020)</a><br/>
                <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/9798893/proceeding ">Volume (2021)</a><br/>
                <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/10216364/proceeding">Volume (2022)</a><br/>
            <Icon icon='link' size="1x"/> <a target="_blank" href="https://ieeexplore.ieee.org/xpl/conhome/1803739/all-proceedings">All CSCI Proceedings</a><br/>

                <br/>
                Since its inception, all CSCI proceedings have always been approved and included
                into IEEE Xplore indexation/digital-library citation databases. The proceedings
                of CSCI have also been included in other major citation index systems (including,
                Ei Compendex, <a href="http://www.engineeringvillage.com" target="_blank" rel="noopener noreferrer">www.engineeringvillage.com</a>; 
                Scopus, <a href="http://scopus.com" target="_blank" rel="noopener noreferrer">scopus.com</a>, IEEE Xplore, and others). Content of CSCI 2023 will be submitted to the indexing companies for possible indexing.
            </div>

            <h6 className="par_header">INSTRUCTIONS FOR SUBMISSION OF PAPERS FOR EVALUATION:</h6>
            <div className="par">
                Authors of accepted papers must agree with the standard
                <a target="_blank" href="https://www.computer.org/web/cs-cps/copyright"> IEEE CPS statement in reference to Copyrights (Intellectual Property Rights) </a>
                and 
                <a target="_blank" href="https://www.ieee.org/publications_standards/publications/rights/index.html"> Policy on Electronic Dissemination</a>


                <br/><br/>

                Papers should be typeset by using the general typesetting
                instructions available at (select "US letter" option for accessing templates): 
                <a href="https://www.ieee.org/conferences_events/conferences/publishing/templates.html" target="_blank" rel="noopener noreferrer"> https://www.ieee.org/conferences_events/conferences/publishing/templates.html </a> 
                (i.e., single line spacing, 2-column format). <br/>
                All submissions must be original
                (papers must not have been previously published or currently being considered
                by others for publication).

                <br/><br/>

                Submissions must be in either MS doc or pdf formats (7  pages for Regular Research Papers; 5 pages for Short Papers; 3 pages for Poster Papers - the number of pages includes all figures, tables, and references - if the authors need extra pages, then the editors would permit one extra page above and beyond the maximum number of pages stated <a target="_blank" href="https://www.american-cse.org/csci2023/paper_categories"> here </a> at no extra charge). The first page should include:

                <br/><br/>

                - Title of the paper <br/>
                - Name, affiliation, city, country, and email address of each 
                    author (identify the name of the Contact Author) <br/>
                - Abstract (about 100 words) <br/>
                - A maximum of 5 topical keywords that would best represent the
                    work described in the paper <br/>
                - Write the type of the submission as "Full/Regular Research Paper", "Short Paper", or 	"Poster Paper" <br/>
                - Write the acronym of the most relevant research track that this
                    paper is being submitted to <br/>
                - The acronyms are: <br/>
                    <div>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTCS">Research Track on Computational Science (CSCI-RTCS)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTCI">Research Track on Computational Intelligence (CSCI-RTCI)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTCW">Research Track on Cyber Warfare, Cyber Defense, & Cyber Security (CSCI-RTCW)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTPC">Research Track on Signal & Image Processing, Computer Vision & Pattern Recognition (CSCI-RTPC)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTSC">Research Track on Smart Cities and Smart Mobility (CSCI-RTSC)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTED">Research Track on Education (CSCI-RTED) - includes accreditation, such as ABET</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTHI">Research Track on Health Informatics and Medical Systems (CSCI-RTHI)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTMC">Research Track on Mobile Computing, Wireless Networks, & Security (CSCI-RTMC)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTSE">Research Track on Software Engineering (CSCI-RTSE)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTOT">Research Track on Internet of Things & Internet of Everything (CSCI-RTOT)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTBD">Research Track on Big Data and Data Science (CSCI-RTBD)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTAI">Research Track on Artificial Intelligence (CSCI-RTAI)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTNA">Research Track on Social Network Analysis, Social Media, & Mining (CSCI-RTNA)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTCC">Research Track on Cloud Computing and Data Centers (CSCI-RTCC)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTCB">Research Track on Computational Biology (CSCI-RTCB)</Link><br/>
                    <Icon icon='link' size="1x"/> <Link to="/csci2023/RTPD">Research Track on Parallel & Distributed Computing (CSCI-RTPD)</Link><br/>
                </div>

                <br/>
                The actual paper can start from the first page (space permitting)
                <br/> <br/>
                Submissions are to be uploaded to the submission/evaluation web
                site portal at: <a target="_blank" href="https://american-cse.org/drafts/">https://american-cse.org/drafts/</a>

            </div>
            
            
          
          </div>
          

        </div>
      </div>
    );
  }
}

export default PaperS;